const MAX_FEATURED_ITEMS = 6

export function cleanFeaturedItems (menuBlob) {
  const featuredItems = menuBlob.onlineFeaturedItems
  if (!featuredItems || !featuredItems.length) {
    return
  }
  const locationFeaturedItems = featuredItems.filter(item => item.$added)
  if (locationFeaturedItems.length > 0) {
    featuredItems.splice(0, featuredItems.length, ...locationFeaturedItems)
  }
  for (let i = featuredItems.length - 1; i >= 0; i--) {
    const okItem = !featuredItems[i].departmentId || validItem(menuBlob, featuredItems[i])
    if (!okItem) {
      featuredItems.splice(i, 1)
    }
  }
  featuredItems.splice(MAX_FEATURED_ITEMS)
}

function validItem (menuBlob, item) {
  const dep = menuBlob.departments.find(d => d.id === item.departmentId)
  if (!isAvailable(dep)) {
    return false
  }
  const cat = dep.categories && dep.categories.find(c => c.id === item.categoryId)
  const itm = dep.items && dep.items.find(i => i.id === item.itemId)
  return isAvailable(cat) && isAvailable(itm)
}

function isAvailable (obj) {
  return obj && obj.info && obj.info.status !== 'INACTIVE'
}
